import React, { useState, useRef, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const tomos = [{
  id: 1,
  title: 'Tomo 1 — Protocolo de Desintoxicación Digital',
  image: 'https://cdn.magicpatterns.com/uploads/8VngrR6sJkkxScUG5hJZa5/TOMO_1.png'
}, {
  id: 2,
  title: 'Tomo 2 — El Libro de los Porqués',
  image: 'https://cdn.magicpatterns.com/uploads/vfATqjc6zZjhP2PHdCmgad/TOMO_2.png'
}, {
  id: 3,
  title: 'Tomo 3 — Desafíos Ninja',
  image: 'https://cdn.magicpatterns.com/uploads/7frAzKVbyyT1qQ4dWTCRp9/TOMO_3.png'
}, {
  id: 4,
  title: 'Tomo 4 — El Arte de Esperar',
  image: 'https://cdn.magicpatterns.com/uploads/cRAQkXCrfHHZZTfqqdAyWp/TOMO_4.png'
}, {
  id: 5,
  title: 'Tomo 5 — Conexión Profunda',
  image: 'https://cdn.magicpatterns.com/uploads/rvJwnqKEjcBpryg79g3dnu/TOMO_5.png'
}, {
  id: 6,
  title: 'Tomo 6 — El Planificador Visual',
  image: 'https://cdn.magicpatterns.com/uploads/hMQ3rp2Dd95JS9RNTVMAp8/TOMO_6.png'
}];
export function TomosCarousel() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const cardWidth = scrollRef.current.querySelector('div')?.offsetWidth || 300;
    const gap = 24;
    const scrollAmount = cardWidth + gap;
    const newScroll = direction === 'left' ? scrollRef.current.scrollLeft - scrollAmount : scrollRef.current.scrollLeft + scrollAmount;
    scrollRef.current.scrollTo({
      left: newScroll,
      behavior: 'smooth'
    });
  };
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const cardWidth = scrollRef.current.querySelector('div')?.offsetWidth || 300;
    const gap = 24;
    const index = Math.round(scrollRef.current.scrollLeft / (cardWidth + gap));
    setActiveIndex(Math.min(index, tomos.length - 1));
  };
  return <section className="bg-dark-900 py-16 px-4 overflow-hidden pl-[16px] pr-[16px]" data-id="element-273">
      <div className="max-w-6xl mx-auto" data-id="element-274">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-bold text-cream text-center mb-10" data-id="element-275">
          📚 Lo que vas a recibir (6 Tomos completos listos para usar)
        </motion.h2>

        <div className="relative" data-id="element-276">
          {/* Left Arrow */}
          <button onClick={() => scroll('left')} className="hidden md:flex absolute -left-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-dark-800 border border-primary/30 rounded-full items-center justify-center text-cream hover:bg-primary/20 transition-colors shadow-lg" aria-label="Anterior" data-id="element-277">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-278" />
          </button>

          {/* Right Arrow */}
          <button onClick={() => scroll('right')} className="hidden md:flex absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-dark-800 border border-primary/30 rounded-full items-center justify-center text-cream hover:bg-primary/20 transition-colors shadow-lg" aria-label="Siguiente" data-id="element-279">
            <ChevronRightIcon className="w-6 h-6" data-id="element-280" />
          </button>

          {/* Carousel */}
          <div ref={scrollRef} onScroll={handleScroll} className="flex gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-4 scrollbar-hide" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-281">
            {tomos.map((tomo, index) => <motion.div key={tomo.id} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="flex-shrink-0 snap-center w-[260px] md:w-[300px]" data-id="element-282">
                <div className="bg-dark-800 rounded-2xl border border-primary/20 overflow-hidden shadow-xl hover:border-primary/50 transition-colors" data-id="element-283">
                  {tomo.image ? <img src={tomo.image} alt={tomo.title} className="w-full h-auto object-cover" loading="lazy" data-id="element-284" /> : <div className="w-full aspect-[3/4] bg-dark-800 flex flex-col items-center justify-center text-cream/40 border-b border-primary/10" data-id="element-285">
                      <span className="text-5xl mb-3" data-id="element-286">📖</span>
                      <span className="text-sm font-medium" data-id="element-287">Tomo 6</span>
                      <span className="text-xs mt-1" data-id="element-288">(Reemplazar imagen)</span>
                    </div>}
                  <div className="p-4 text-center" data-id="element-289">
                    <p className="text-cream text-sm font-semibold" data-id="element-290">
                      {tomo.title}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Dot Indicators */}
        <div className="flex justify-center gap-2 mt-6" data-id="element-291">
          {tomos.map((_, index) => <button key={index} onClick={() => {
          if (!scrollRef.current) return;
          const cardWidth = scrollRef.current.querySelector('div')?.offsetWidth || 300;
          const gap = 24;
          scrollRef.current.scrollTo({
            left: index * (cardWidth + gap),
            behavior: 'smooth'
          });
        }} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === activeIndex ? 'bg-primary w-6' : 'bg-cream/30 hover:bg-cream/50'}`} aria-label={`Ir a tomo ${index + 1}`} data-id="element-292" />)}
        </div>

        <p className="text-center text-cream/50 text-sm mt-4 md:hidden" data-id="element-293">
          Deslizá para ver todo 👉
        </p>
      </div>
    </section>;
}